if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.track = this.querySelector('.ht-lightbox-track');
      this.viewport = this.querySelector('.product-media-modal__content');
      this.slides = Array.from(this.querySelectorAll('[data-lightbox-media-id]'));
      this.thumbnails = Array.from(this.querySelectorAll('[data-lightbox-index]'));
      this.index = 0;
      this.addEventListener('click', (event) => {
        const step = event.target.closest('[data-lightbox-step]');
        const thumbnail = event.target.closest('[data-lightbox-index]');
        if (step) this.goTo(this.index + Number(step.dataset.lightboxStep));
        if (thumbnail) this.goTo(Number(thumbnail.dataset.lightboxIndex));
      });
      this.addEventListener('keydown', (event) => {
        if (!this.hasAttribute('open') || event.target.closest('input, textarea, video, iframe, model-viewer')) return;
        const next = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 }[event.key];
        if (next === undefined) return;
        event.preventDefault();
        this.goTo(next);
      });
      this.viewport.addEventListener('dragstart', (event) => event.preventDefault());
      this.viewport.addEventListener('pointerdown', (event) => this.startDrag(event));
      this.viewport.addEventListener('pointermove', (event) => this.moveDrag(event));
      this.viewport.addEventListener('pointerup', (event) => this.endDrag(event));
      this.viewport.addEventListener('pointercancel', () => this.cancelDrag());
      this.viewport.addEventListener('lostpointercapture', () => this.cancelDrag());
    }
    show(opener) {
      super.show(opener);
      const index = this.slides.findIndex((slide) => slide.dataset.lightboxMediaId === opener.getAttribute('data-media-id'));
      this.goTo(index < 0 ? 0 : index, false);
    }
    hide() {
      this.cancelDrag();
      super.hide();
    }
    goTo(index, animate = true) {
      if (!this.slides.length) return;
      const next = Math.max(0, Math.min(index, this.slides.length - 1));
      if (next !== this.index) window.pauseAllMedia();
      this.index = next;
      if (!animate) this.track.style.transition = 'none';
      this.track.style.transform = `translate3d(${-100 * next}%, 0, 0)`;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === next);
        slide.setAttribute('aria-hidden', String(i !== next));
        slide.inert = i !== next;
        if (Math.abs(i - next) <= 1) slide.querySelectorAll('img').forEach((image) => { image.loading = 'eager'; });
      });
      this.thumbnails.forEach((button, i) => {
        if (i === next) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      this.querySelector('[data-lightbox-step="-1"]').disabled = next === 0;
      this.querySelector('[data-lightbox-step="1"]').disabled = next === this.slides.length - 1;
      this.querySelector('[data-lightbox-counter]').textContent = `${String(next + 1).padStart(2, '0')} / ${String(this.slides.length).padStart(2, '0')}`;
      this.querySelector('[data-lightbox-status]').textContent = `Imagen ${next + 1} de ${this.slides.length}`;
      const selected = this.thumbnails[next];
      if (selected) {
        const strip = selected.parentElement;
        strip.scrollLeft = selected.offsetLeft - (strip.clientWidth - selected.clientWidth) / 2;
      }
      if (!animate) {
        void this.track.offsetWidth;
        this.track.style.transition = '';
      }
    }
    startDrag(event) {
      if (!event.isPrimary) { this.cancelDrag(); return; }
      if (event.button !== 0 || event.target.closest('button, video, iframe, model-viewer, deferred-media')) return;
      this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY };
      this.viewport.setPointerCapture(event.pointerId);
    }
    moveDrag(event) {
      if (!this.drag || this.drag.id !== event.pointerId) return;
      let dx = event.clientX - this.drag.x;
      const dy = event.clientY - this.drag.y;
      if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 12) { this.cancelDrag(); return; }
      if ((this.index === 0 && dx > 0) || (this.index === this.slides.length - 1 && dx < 0)) dx *= 0.2;
      dx = Math.max(-this.viewport.clientWidth, Math.min(dx, this.viewport.clientWidth));
      this.track.style.transition = 'none';
      this.track.style.transform = `translate3d(calc(${-100 * this.index}% + ${dx}px), 0, 0)`;
    }
    endDrag(event) {
      if (!this.drag || this.drag.id !== event.pointerId) return;
      const dx = event.clientX - this.drag.x;
      const dy = event.clientY - this.drag.y;
      this.drag = null;
      this.track.style.transition = '';
      const direction = Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.2 ? (dx < 0 ? 1 : -1) : 0;
      this.goTo(this.index + direction);
      if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
    }
    cancelDrag() {
      if (!this.drag) return;
      this.drag = null;
      this.track.style.transition = '';
      this.goTo(this.index);
    }
  });
}
